import React, { useEffect } from "react";
import styles from "./reviewProductDetails.module.scss";
import StarIcon from "@mui/icons-material/Star";
import productImg1 from "../../../assets/images/productDeatilsImg.jpg";
import productImg2 from "../../../assets/images/productDeatilsImg2.jpg";
import productImg3 from "../../../assets/images/productDeatilsImg3.jpg";
import productImg4 from "../../../assets/images/productDeatilsImg4.jpg";
import productImg5 from "../../../assets/images/productDeatilsImg5.jpg";
import productImg6 from "../../../assets/images/productDeatilsImg6.jpg";
import DescriptionTile from "../descriptionTile/DescriptionTile";
import { connect, useDispatch } from "react-redux";
import { getAllProduct } from "../../../store/actions";
import { getObjectFromArrayOfObjects } from "../../../utils/common/CommonFunctions";

const ReviewProductDetails = ({ product, products = [] }) => {
  //   const images = [
  //   productImg2,
  //   productImg3,
  //   productImg4,
  //   productImg5,
  //   productImg6,
  // ];
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllProduct());
  }, []);
  useEffect(() => {
    console.log("product is comming in this page", product);
  }, [product]);
  useEffect(() => {
    console.log("getAllProduct", products);
  }, [products]);
  const getProductsByProductId = (productId) => {
    const getProducts = getObjectFromArrayOfObjects(products, "id", productId);
    return getProducts;
  };

  return (
    <div className={styles.container}>
      <div className={styles.imageSection}>
        <div className={styles.imgContainer}>
          <img
            src={getProductsByProductId(product?.productId)?.imageUrl}
            alt="main"
            className={styles.mainImage}
          />
        </div>

        {/* <div className={styles.thumbnailContainer}>
          {images.map((imgSrc, index) => (
            <img
              key={index}
              src={imgSrc}
              alt={`thumb-${index}`}
              className={styles.thumbnail}
            />
          ))}
        </div> */}
      </div>

      <div className={styles.detailsSection}>
        <div className={styles.header}>
          {/* <div className={styles.category}>Goat Products</div> */}
          <div className={styles.title}>{product?.tittle}</div>
          <div className={styles.description}>{product?.description}</div>
          <div className={styles.rating}>
            {/* <StarIcon className={styles.star} />
            <span>{product?.rating}</span> */}
            <div>
              {[...Array(5)].map((_, index) => (
                <span
                  key={index}
                  style={{
                    fontSize: "24px",
                    color: index < product?.rating || 0 ? "gold" : "gold",
                  }}
                >
                  {index < product?.rating || 0 ? "★" : "☆"}
                </span>
              ))}
            </div>
            {/* <span className={styles.reviews}>(15 reviews)</span> */}
          </div>
        </div>

        <div className={styles.priceSection}>
          <span className={styles.price}>
            {getProductsByProductId(product?.productId)?.price}
          </span>

          {/* <span className={styles.originalPrice}>₹500</span> */}
        </div>

        <div className={styles.meta}>
          <div className={styles.label}>
            Size/Volume :
            {getProductsByProductId(product?.productId)?.siUnit ||
              "Size/Volume : 30 ml , 60 ml , 80 ml , 100 ml"}
          </div>
          <div className={styles.sku}>
            SKU : {getProductsByProductId(product?.productId)?.skuId}
          </div>
          <div className={styles.tags}>
            Tags :
            {getProductsByProductId(product?.productId)?.keywords?.join(", ")}
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state, props) => {
  return {
    products: state?.product?.products,
  };
};
export default connect(mapStateToProps, null)(ReviewProductDetails);
